import React from "react";

const Home = () => {
  return (
    <div className="text-center w-full h-full box">
      <h1>Welcome, you people!</h1>
      <br />
      <p className="text">
        This site is Haikuatry,
        <br />
        The home of Haiku
        <br />
        <br />
        Haiku are poems
        <br />
        With five, then seven, then five
        <br />
        Syllables (sound things)
        <br />
        <br />
        Become emotion,
        <br />
        Walk through the door of Haiku,
        <br />
        Experience art
        <br />
      </p>
    </div>
  );
};

export default Home;
